/** @format */

const homeDustLogs = {
  // 主页曝光
  homePageShowLog: {
    event: 'page_show',
    params: {
      page: 'home',
    },
  },
  top5PaperClickLog: {
    event: 'click',
    params: {},
  },
  feedPaperClickLog:{
    event: 'click',
    params: {
      from: "feed",
    },
  }
};

export default homeDustLogs;
